import React from 'react';
import { Reveal, Eyebrow, useSeo } from './site/ui';
import { STORIES } from './site/stories';
import { LogoWall, SampleNote, WorkshopLogo } from './site/Stories';
import { Closing } from './site/HomeSections2';

const Block = ({ label, text }) => (
  <div>
    <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#0f766e]">{label}</p>
    <p className="mt-2 text-[15px] leading-relaxed text-[#334155]">{text}</p>
  </div>
);

const CaseStudy = ({ s, i }) => (
  <Reveal as="article" id={s.slug} className="grid gap-10 border-t border-[#e7e5df] py-16 lg:grid-cols-[1fr_1.2fr]" data-testid={`case-study-${s.slug}`}>
    <div className={i % 2 ? 'lg:order-2' : ''}>
      <img src={s.image} alt={`${s.segment} floor`} loading="lazy" className="aspect-[4/3] w-full rounded-3xl object-cover" />
      <div className="mt-6 grid grid-cols-3 gap-3">
        {s.metrics.map(([v, l]) => (
          <div key={l} className="rounded-2xl bg-[#ffffff] p-4">
            <p className="dl-display text-2xl font-semibold text-[#0f172a]">{v}</p>
            <p className="mt-1 text-xs text-[#475569]">{l}</p>
          </div>
        ))}
      </div>
    </div>
    <div>
      <WorkshopLogo s={s} size="lg" />
      <p className="mt-2 text-sm text-[#64748b]">{s.segment} · {s.city}</p>
      <blockquote className="dl-display mt-6 text-2xl font-semibold leading-snug text-[#0f172a]">“{s.quote}”</blockquote>
      <p className="mt-3 text-sm text-[#475569]">— {s.owner}, {s.role}</p>
      <div className="mt-8 space-y-6">
        <Block label="Before" text={s.before} />
        <Block label="What changed" text={s.changed} />
        <Block label="Today" text={s.after} />
      </div>
    </div>
  </Reveal>
);

export default function DrivelineStories() {
  useSeo({
    title: 'Workshop stories · Driveline',
    description: 'How detailing studios, body shops, service workshops and parts counters run their day on Driveline.',
  });
  return (
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-28 sm:px-8 sm:pt-32" data-testid="driveline-stories">
      <Eyebrow>Workshop stories</Eyebrow>
      <h1 className="dl-display mt-4 max-w-3xl text-4xl font-semibold leading-[1.05] tracking-tight text-[#0f172a] sm:text-5xl lg:text-6xl">Four workshops, four ways of working, one system.</h1>
      <SampleNote />
      <div className="mt-12"><LogoWall /></div>
      <div className="mt-12">{STORIES.map((s, i) => <CaseStudy key={s.slug} s={s} i={i} />)}</div>
      <div className="-mx-5 mt-8 sm:-mx-8"><Closing title="Want a story like this for your workshop?" /></div>
    </div>
  );
}
